import { Icon, IconProps } from '@chakra-ui/icons'

export default function PersonsMyGroupIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <circle
        cx="7.99829"
        cy="8.51099"
        r="3.49145"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="17.0021"
        cy="9.50104"
        r="2.50104"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.99585 20.006V18.9886C1.99585 16.7876 3.77959 15.0039 5.98051 15.0039H10.0162C12.2171 15.0039 14.0008 16.7876 14.0008 18.9886V20.006"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0021 15.0039H18.1045C20.3055 15.0039 22.0892 16.7876 22.0892 18.9886V20.006"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
